import { useEffect, useState } from "react";
import TranslationGetHOC from "../../../components/layout/TranslationGetHOC";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, Stack, Button } from "@mui/material";
import { AppAPiUrl, AppRoutesPath } from "../../../configs/appData";
import MaterialReactDataTable from "../../../components/layout/MaterialReactDataTable";
import LoaderScreen from "../../../components/layout/LoaderScreen";
import { priceFormatWithCurrency } from "../../../components/layout/Helper";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import colorConfigs from "../../../configs/colorConfigs";

function WholeSaleListPageComponent(props:any){
    const navigate = useNavigate();
    const location = useLocation();
    const { preserveData } = location.state || null;
    const [iComponetTranslate, setICTranslation] = useState([]);
    const [isTransLoaded, setLoaded] = useState(false);
    const [tableTotalPrice, setTableTotalPrice] = useState('');
    const [paramObject, setParamObject]= useState({});
    const [totalPriceCurrency, setTotalPriceCurrency] = useState([]);
    const [tableDataShow, setTableDataShow] = useState([]);
    const param = useParams();
    const { id } = param;
    const { appCountry } = useSelector((state: RootState) => state.appState);


    const t = (name: string) => {
        const ifExist: any = iComponetTranslate.filter((item: any) => item.label === name);
        if (ifExist.length > 0) {
            return ifExist[0].value ? ifExist[0].value : `No translate found (${ifExist[0].label})`;
        }
        return `No key found (${name})`;
    }
    const whileSaleTableRow = [
        {
            accessorKey: 'product',
            header: t('Product'),
            accessorFn: (row: any) => row?.product?.display_name || "-",
        },
        {
            accessorKey: 'quantity',
            header: t('Amount'),
            size: 230,
            accessorFn: (row: any) => row?.quantity,
            // enableSorting: false,
            // enableFilters: true,
            // enableColumnFilterModes: false,
            // enableColumnFilters: false,
            // enableColumnActions: false,
            // enableColumnFilter: false,
        },
        {
            accessorKey: 'price_unit',
            header: t('UnitPrice'),
            size: 230,
            accessorFn: (row: any) => row?.price_unit,
            // enableSorting: false,
            // enableFilters: true,
            // enableColumnFilterModes: false,
            // enableColumnFilters: false,
            // enableColumnActions: false,
            // enableColumnFilter: false,
        },
        {
            accessorKey: 'price_subtotal',
            header: t('sub_total'),
            size: 230,
            accessorFn: (row: any) => row?.price_subtotal,
            // enableSorting: false,
            // enableFilters: true,
            // enableColumnFilterModes: false,
            // enableColumnFilters: false,
            // enableColumnActions: false,
            // enableColumnFilter: false,
        },
        {
            accessorKey: 'price_total',
            header: t('Total'),
            size: 230,
            accessorFn: (row: any) => row?.price_total,
            // enableSorting: false,
            // enableFilters: true,
            // enableColumnFilterModes: false,
            // enableColumnFilters: false,
            // enableColumnActions: false,
            // enableColumnFilter: false,
        },
        {
            accessorKey: 'commission',
            header: t('Commission'),
            accessorFn: (row: any) => row?.commission,
        },
    ];
    const getpopDate = (row: any, tableData: any) => console.log(row);
    const cmSetTableData = (rows: any) => setTableDataShow(rows);
    useEffect(() => {
        const { translateDataft } = props;
        const newCode = appCountry.toLocaleLowerCase();
        if (translateDataft && translateDataft.hasOwnProperty(`${newCode}`)) {
            setICTranslation(translateDataft[`${newCode}`]);
            setTimeout(() => {
                setLoaded(true);
            }, 100);
        }
        else {
            setICTranslation([]);
            setLoaded(true);
        }
    }, [props, appCountry]);
    
    const handleTotalPrice = (data: any) => {
        // Convert commission to float by removing currency symbols and parse to number
        let newData = data.map((item: any) => {
            // Remove non-numeric characters (like '€') from the commission field and convert to number
            const commissionValue = item.commission.replace(/[^\d.-]/g, '');
            return parseFloat(commissionValue) || 0; // Ensure it's a number and default to 0 if NaN
        });
    
        const total = newData.reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0);
        const totalPrice = total.toFixed(2); // Ensure we always show two decimal places
    
        // You can modify the currency symbol based on the country or app settings
        const currencySymbol = totalPriceCurrency.length > 0 ? totalPriceCurrency[0] : "€"; // Default to "€" if no currency set
        const formatted_total_price = `${totalPrice} ${currencySymbol}`
        setTableTotalPrice(formatted_total_price);  // Add currency symbol with the total
    };
    return(
        <Box className='cm-global-tabs-wrapper' sx={{ overflow: "hidden",  marginTop: "20px" }}>
             <Stack direction="row" spacing={2} alignItems="center" justifyContent={"start"} sx={{ marginBottom: "20px" }}>
                <Button variant="contained" startIcon={<ArrowBackIosIcon />}
                  className="cm-btn-sm-style"
                  sx={{
                    color: colorConfigs.btnColor.hoverbgWhite,
                    background: colorConfigs.btnColor.bgColorRed,
                    "&: hover": {
                      color: colorConfigs.btnColor.bgColorRed,
                      background: colorConfigs.btnColor.hoverbgWhite,
                    }
                  }} onClick={() => navigate(AppRoutesPath.WholeSaleCommission, {state:{preserveData:preserveData}})}>{t('Back')}</Button>
              </Stack>
            {isTransLoaded  ? 
        <div className='cm-form-inner-fields cm-pagination-billing-dt cm-table-remvove-style'>
             <MaterialReactDataTable
                apiLink={`${AppAPiUrl.WholeSaleList}${id}/`}
                tRow={whileSaleTableRow}
                paramDependent={paramObject} 
                clickFunc={getpopDate}
                setTableDataShow={cmSetTableData}
                callbackFunction={handleTotalPrice}
                /> 
            <Stack direction="row" spacing={2} alignItems="center" justifyContent={"end"} className="sub-table-price">
                <Box>
                    <Box className='cm-order-sale-total-tbl' sx={{ borderTop: 'none', marginTop: "20px" }}>
                        <Box className='order-sale-table-data tfoot'>
                        <Stack direction="row" spacing={2} alignItems="center" justifyContent={"between"}>
                            <Box className='order-sl-th'>{t('Total')} : {tableTotalPrice}</Box>
                            {/* <Box className='order-sl-td'>{totalPriceCurrency.length > 0 &&
                            priceFormatWithCurrency(totalPriceCurrency, tableTotalPrice)
                            }</Box> */}
                        </Stack>
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </div>
        : <LoaderScreen/>}
</Box>
    )
}

function WholeSaleListPage({ isAllow }: any) {
    const dependency = { require: ['Sidebar'] };
    const MainComponent = TranslationGetHOC(WholeSaleListPageComponent, "accounting_billing", isAllow, {}, dependency);
    return <MainComponent />
}

export default WholeSaleListPage